<div class="modalCancel">
  <div class="backArrowSection">
    <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
  </div>

  <div class="description-img">
    <img src="assets/imgs/new-check-img.svg" alt="{{ 'validationLogoAlt' | translate }}">
  </div>

  <div class="title">{{ 'newPhotoValidation' | translate }}</div>

  <span class="description">
    {{ 'newPhotoApprovedDescription' | translate }}
  </span>

  <div style="border:1px solid var(--ion-background-color); display: flex; justify-content: center;">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button (click)="continue()" class="buttonShadow" expand="full" shape="round" fill="solid" color="primary">
            {{ 'continueButton' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
